import React from "react";
import { Card, Button, LinearProgress, Box } from "@mui/material";
import "../styles/DueDiligence.css";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import InsertChartIcon from "@mui/icons-material/BarChart";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { linearProgressClasses } from "@mui/material/LinearProgress";
import { getProgressColor, getRiskStyle } from "../utils/companyUtils";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import secureLocalStorage from "react-secure-storage";

const DueDiligenceCard = ({ company }) => {
  //#region click events
  const onDueDiligenceClick = () => {
    secureLocalStorage.setItem("selectedCompanyId", company.id);
    navigate(`/due-diligence/data-room/${company.id}`);
  };

  //#region return
  const navigate = useNavigate();

  const progressValue = company.dd_progress > 0 ? company.dd_progress : 20;
  return (
    <Card className="company-card">
      <div className="company-header">
        <div>
          <div className="company-title">
            {company.name || "Tech Solutions"}
          </div>
          <div className="gray-text">{company.industry || "SaaS Platform"}</div>
        </div>
        <div className="risk-badge-box" style={getRiskStyle(company.risk)}>
          <span className="risk-badge">{company.risk || "Low Risk"}</span>
        </div>
      </div>

      <div className="company-info">
        <div>
          <div className="gray-text">Revenue</div>
          <div className="common-text">${company.revenue || 0}</div>
        </div>
        <div>
          <div className="gray-text">Employees</div>
          <div className="common-text">{company.employees_count || 0}</div>
        </div>
      </div>

      <div className="company-location">
        <div>
          <div className="gray-text">Location</div>
          <div className="common-text">{company.location || "Austin, TX"}</div>
        </div>
      </div>

      <div className="company-progress">
        <div className="progress-info">
          <div className="common-text">DD Progress</div>
          <div className="common-text">{progressValue}%</div>
        </div>
        {/* progress bar */}
        <LinearProgress
          variant="determinate"
          value={progressValue} // use progressValue here
          sx={{
            height: 10,
            borderRadius: 5,
            [`&.${linearProgressClasses.colorPrimary}`]: {
              backgroundColor: "#e6e6e6",
            },
            [`& .${linearProgressClasses.bar}`]: {
              backgroundColor: getProgressColor(progressValue), // use progressValue here too
            },
          }}
        />
        <div className="gray-text" style={{ marginTop: "8px" }}>
          Last Activity: {company.lastActivity || "2 hours ago"}
        </div>
      </div>

      <div className="company-actions">
        <Button
          variant="outlined"
          startIcon={<DescriptionOutlinedIcon />}
          className="card-btn"
          onClick={onDueDiligenceClick}
        >
          Data Room
        </Button>
        <Button
          variant="outlined"
          startIcon={<InsertChartIcon />}
          className="card-btn"
        >
          Analytics
        </Button>
      </div>

      <div className="company-actions">
        <Button
          startIcon={<CloseIcon />}
          className="card-btn"
          onClick={() => console.log("Remove clicked")}
        >
          Remove
        </Button>
        <Button
          startIcon={<CheckCircleOutlineIcon />}
          className="dd-btn"
          onClick={onDueDiligenceClick}
        >
          Start DD
        </Button>
      </div>
    </Card>
  );
};

export default DueDiligenceCard;
